export enum Status{
    Online = 'Online',
    Offline = 'Offline',
    Busy = 'Busy',
    AppearOffline = 'AppearOffline',
    Away = 'Away'
}


// WEBPACK FOOTER //
// ./src/enum/status.ts